export var PromptCategory;
(function (PromptCategory) {
    PromptCategory["CLASSIFICATION"] = "CLASSIFICATION";
    PromptCategory["EXTRACTION"] = "EXTRACTION";
    PromptCategory["VALIDATION"] = "VALIDATION";
    PromptCategory["TRANSLATION"] = "TRANSLATION";
})(PromptCategory || (PromptCategory = {}));
export var DocumentType;
(function (DocumentType) {
    DocumentType["PROOF_OF_ENROLLMENT"] = "proof_of_enrollment";
    DocumentType["PROOF_OF_PAYMENT"] = "proof_of_payment";
    DocumentType["PROOF_OF_COMPLETION"] = "proof_of_completion";
    DocumentType["TUITION_BILL"] = "tuition_bill";
    DocumentType["RECEIPT"] = "receipt";
    DocumentType["TRANSCRIPT"] = "transcript";
    DocumentType["SYLLABUS"] = "syllabus";
    DocumentType["GENERIC_DOCUMENT"] = "generic_document";
    DocumentType["UNKNOWN"] = "unknown";
})(DocumentType || (DocumentType = {}));
